import SContentWrapper from "src/components/contentwrapper/ContentWrapper";
import Quiz from "src/components/filmquiz/Quiz";
import FilmwebNews from "src/components/filmwebnews/FilmwebNews";
import FilmQuizSeo from "src/components/seo/FilmQuizSeo";
import StreamingSearchBox from "src/components/streaming/StreamingSearchBox";
import { FRONTPAGE_NEWS, filterOtherNews } from "src/lib/groq";
import { setDefaultCacheHeaders } from "src/lib/server/cache";
import { ICommonProps, getServerData, sanityQuery } from "src/lib/server/sanity";
import styled from "src/lib/styles/css";
import IFilmnytt from "src/lib/types/Filmnytt";
import { GetServerSideProps } from "next";

//#region [Other]getServerSideProps
export const getServerSideProps: GetServerSideProps = getServerData(async (context) => {

	const otherNews = await sanityQuery<IFilmnytt[]>(FRONTPAGE_NEWS);
	setDefaultCacheHeaders(context);

	return {
		props: {
			otherNews: filterOtherNews(otherNews)?.slice(0, 3) ?? null,
		}
	};


});
//#endregion


//#region [Props]
export type FilmquizProps = {
	otherNews: IFilmnytt[] | null;
} & ICommonProps;
//#endregion

//#region [Component]
export default function Filmquiz({ appData, otherNews }: FilmquizProps) {
	return <SContentWrapper>
		<FilmQuizSeo />
		<Quiz />
		<SFilmwebNews articles={otherNews} />
		<SStreamingSearchBox toolbox={appData.streamingToolbox} />
	</SContentWrapper>
}
//#endregion

//#region [Styles]
const SFilmwebNews = styled(FilmwebNews)`
	margin-bottom: 30px;
`;

const SStreamingSearchBox = styled(StreamingSearchBox)`
	margin-bottom: 30px;
`;
//#endregion